<app-template-text
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [maxlength]="maxlength"
  [required]="required"
  [disabled]="disabled"
  [label]="label"
/>
